module.exports = __webpack_public_path__ + "img/Selo2.91965297.svg";